import { useProjectContext } from '~/hooks';
import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import Totals from './Totals';
import ProjectArraySection from './ProjectArray';
import { useDerivedRECFields } from '~/features/projectWizard/derived';
import { Button } from '~/components';
import './styles.scss';

export default function PV() {
  const { project, updateProjectValue } = useProjectContext();

  useDerivedRECFields();

  const addArray = () => {
    const projectArrays = project.projectArrays ?? [];
    updateProjectValue('projectArrays', [
      ...projectArrays,
      { projectId: project.id, order: projectArrays.length, startOpen: true },
    ]);
  };

  const hasArrays = (project.projectArrays?.length ?? 0) > 0;

  return (
    <WorksheetForm>
      <Totals />
      <div>
        {hasArrays ? (
          <>
            {project.projectArrays?.map((projectArray) => (
              <ProjectArraySection key={projectArray.id} projectArray={projectArray} />
            ))}
            <div className="collapsible-card-list-actions">
              <Button variant="link" onClick={addArray}>
                + Add another array
              </Button>
            </div>
          </>
        ) : (
          <div className="collapsible-card-empty">
            <p>No arrays configured yet</p>
            <Button variant="link" onClick={addArray}>
              + Add array
            </Button>
          </div>
        )}
      </div>
    </WorksheetForm>
  );
}
